export default (l33tTable, triNode) => {
    Object.entries(l33tTable).forEach(([letter, substitutions]) => {
        substitutions.forEach((substitution) => {
            triNode.addSub(substitution, letter);
        });
    });
    return triNode;
};
//# sourceMappingURL=l33tTableToTrieNode.js.map